var map = {
	"./elasticsearch.svg": "6f89f",
	"./field-boolean.svg": "3db4",
	"./field-byte.svg": "4e0c",
	"./field-constant_keyword.svg": "8451",
	"./field-date.svg": "88fe",
	"./field-double.svg": "6ae2",
	"./field-float.svg": "1ddaf",
	"./field-half_float.svg": "c91e",
	"./field-integer.svg": "c0cc",
	"./field-ip.svg": "d644",
	"./field-keyword.svg": "7472",
	"./field-long.svg": "8767",
	"./field-nested.svg": "30d7",
	"./field-object.svg": "b52b",
	"./field-point.svg": "4945",
	"./field-range.svg": "ad76",
	"./field-scaled_float.svg": "c3ac",
	"./field-short.svg": "bdd4",
	"./field-text.svg": "aa0a",
	"./field-unknown.svg": "ccc9",
	"./field-wildcard.svg": "8ee3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";